import { useGetSettings } from 'shared/hooks/payment-api/settings-endpoint';
import { ThemeColor } from 'shared/types/themeColor';
import { useAuth } from 'shared/providers/Auth';

export const useGetFormattedSettings = () => {
  const { isLoggedIn } = useAuth();

  const {
    data: settingsData,
    isLoading: settingsLoading,
    error: settingsError
  } = useGetSettings({
    query: {
      staleTime: Infinity,
      enabled: isLoggedIn,
      useErrorBoundary: false
    }
  });

  return {
    localization: settingsData?.localization,
    error: settingsError,
    isLoading: settingsLoading,
    logoUrl: settingsData?.visual.logoUrl,
    favIconUrl: settingsData?.visual.favIconUrl,
    parentPortalUrl: settingsData?.parentPortalUrl,
    schoolName: settingsData?.schoolName || 'Loading...',
    colors: settingsData?.visual.theme.colors as unknown as ThemeColor,
    disableOneOffPayments: settingsData?.disableOneOffPayments,
    reEnrolment: settingsData?.reEnrolment,
    isSiteAvailable: settingsData?.isSiteAvailable ?? true,
    scheduleMaintenance: settingsData?.scheduleMaintenance,
    allowDueDateOrdering: settingsData?.visual.allowInvoiceDueDateOrdering ?? false,
    data: settingsData
  };
};
